import React from 'react';
import { LockIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
type SectionCtaProps = {
  label: string;
  tone?: 'light' | 'dark';
};
export function SectionCta({
  label,
  tone = 'light'
}: SectionCtaProps) {
  return <div className="mt-12 flex flex-col items-center text-center" data-id="element-279" data-mp="3id6xf85hr2aw">
      <CtaButton label={label} className="sm:min-w-[26rem]" data-id="element-280" data-mp="3nbgtrm2yc8y3" />
      <p className={`mt-4 flex items-center gap-1.5 text-sm ${tone === 'dark' ? 'text-white/75' : 'text-ink/60'}`} data-id="element-281" data-mp="38nnds09yf4ez">
        <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-282" data-mp="3devnkxf74rso" />
        Instant access · USD $27 one-time · 7-Day Guarantee
      </p>
    </div>;
}